import {addClass, removeClass} from "../_vars";

export const priceTableFunc = () => {
   /**
    * Класс представляющий Table
    * @class
    */
   class Table {
      /** Флаг, указывающий, был ли инициирован */
      static #wasInit;
      /** Инициировать */
      static #init() {
         if (this.#wasInit) return;
         this.#wasInit = true;

         addEventListener("click", (e) => {
            const btn = e.target.closest(".--head");
            if (!btn || btn.classList.contains("--ntb")) return;
            const table = e.target.closest(".price-table");
            if (!table) return;

            table._app_.table.rows.forEach(row => {
               if (row.items[0] === btn) {
                  table._app_.table.switchTab(row);
                  table._app_.table.handleScroll(btn);
               }
            });
         })
         addEventListener("mouseover", (e) => {
            const btn = e.target.closest(".col");
            if (!btn) return;
            const table = e.target.closest(".price-table");
            if (!table) return;
            const index = [...btn.parentElement.children].indexOf(btn);
            if (!table._app_.table.rows[index].items[0].matches(".--head:not(.--ntb)")) return;
            table._app_.table.borderRow(table._app_.table.rows[index]);
         });
         addEventListener("mouseout", (e) => {
            const btn = e.target.closest(".col");
            if (!btn) return;
            const table = e.target.closest(".price-table");
            if (!table) return;
            const index = [...btn.parentElement.children].indexOf(btn);
            if (!table._app_.table.rows[index].items[0].matches(".--head:not(.--ntb)")) return;
            table._app_.table.unBorderRow(table._app_.table.rows[index]);
         });
      }
      handleScroll(btn) {
         const parent = btn.parentElement;
         const coords = btn.getBoundingClientRect();
         const offset = parent.scrollLeft + parent.offsetWidth;
         if (offset < coords.right) return parent.scroll(coords.right - parent.offsetWidth, 0);
         if (offset > coords.left) return parent.scroll(parent.scrollLeft - Math.abs(coords.left), 0);
      }
      switchTab(row) {
         this.headIndexes.forEach(index => {
            this.rows[index].items.forEach(item => {
               addClass(item, "--disable-tab");
               removeClass(item, "--active-tab");

            });
         });
         row.items.forEach(item => {
            removeClass(item, "--disable-tab");
            addClass(item, "--active-tab");
         });
      }
      borderRow(row) {
         addClass(row.items[0], "--accent");
         row.items.forEach(item => addClass(item, "--bordered"));
      }
      unBorderRow(row) {
         removeClass(row.items[0], "--accent");
         row.items.forEach(item => removeClass(item, "--bordered"));
      }
      /**
       * Создает Элемент `Table`
       * @param {Element} el Элемент `Table`
       * @property {Element} el Элемент `Table`
       */
      constructor(el) {
         el._app_ ??= {};
         el._app_.table = this;

         this.el = el;
         this.rows = [];
         this.headIndexes = [];
         [...el.children].forEach((row, rowIndex) => {
            [...row.children].forEach((item, index) => {
               if (!this.rows[index]) this.rows[index] = {items: []};
               this.rows[index].items.push(item);

               if (rowIndex === 0 && item.classList.contains("--head") && !item.classList.contains("--ntb")) this.headIndexes.push(index);
               if (item.classList.contains("--accent")) this.rows[index].isAccent = true;
               if (this.rows[index].isAccent) addClass(item, "--bordered");
            });
         });

         this.switchTab(this.rows[this.headIndexes[0]]);
         Table.#init();
      }
   }
   const tables = document.querySelectorAll(".price-table");
   [...tables].forEach(table => new Table(table));
};
